import styled from 'styled-components';
import Modal from 'components/common/Modal.js';
import palette from 'lib/styles/palette';

const AskModal = ({ closeModal, action, message, actionFc }) => {
  return (
    <Modal closeModal={closeModal}>
      <AskModalBlock>
        <div className="text">{message}</div>
        <ActionButtonsWrapper>
          <button onClick={actionFc}>{action}</button>
          <button onClick={closeModal}>취소</button>
        </ActionButtonsWrapper>
      </AskModalBlock>
    </Modal>
  );
};

export default AskModal;

const AskModalBlock = styled.div`
  width: 300px;
  height: 150px;
  display: flex;
  flex-direction: column;

  .text {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
`;

const ActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  button {
    width: 100%;
    height: 50px;
    border: none;
    background: #fff;
    color: ${palette.theme[2]};
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background-color: ${palette.theme[3]};
      color: #fff;
    }
  }

  button + button {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
  }
`;
